import { render, staticRenderFns } from "./reportManagement.vue?vue&type=template&id=b6170088&scoped=true"
import script from "./reportManagement.vue?vue&type=script&lang=js"
export * from "./reportManagement.vue?vue&type=script&lang=js"
import style0 from "./reportManagement.vue?vue&type=style&index=0&id=b6170088&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6170088",
  null
  
)

export default component.exports